var angular = require('angular');

var toDate = require('./util').toDate;
var delayHuman = require('./util').delayForHumans;
var delayMinutes = require('./util').delayInMinutes;
var formatPhone = require('./util').formatPhone;

function DistributionRoute(route, distribution) {
  this.update(route, distribution);
}

DistributionRoute.prototype.update = function(route, distribution) {
  angular.extend(this, route);
  this.estimatedTimestampStart = toDate(this.estimatedTimestampStart);
  this.estimatedTimestampStop = toDate(this.estimatedTimestampStop);
  this.estimatedTimestampDelivery = toDate(this.estimatedTimestampDelivery);
  this.timestampStart = toDate(this.timestampStart);
  this.timestampStop = toDate(this.timestampStop);
  this.timestampDelivery = toDate(this.timestampDelivery);
  this.companyName = companyName(route, distribution);
};

var companyName = function(route, distribution) {
  return distribution.findRoutePlan(route.routePlanId).companyName;
};

DistributionRoute.prototype.delayInMinutes = function() {
  if (! this.timestampStart) {
    return delayMinutes(new Date(), this.estimatedTimestampStart);
  }

  if (this.timestampStop) {
    return delayMinutes(this.timestampStop, this.estimatedTimestampStop);
  }

  if (this.timestampDelivery) {
    return delayMinutes(this.timestampDelivery, this.estimatedTimestampDelivery);
  }

  return delayMinutes(this.timestampStart, this.estimatedTimestampStart);
};
DistributionRoute.prototype.delayForHumans = function() {
  return delayHuman(this.delayInMinutes());
};


DistributionRoute.prototype.driverPhone = function() {
  return this.driver.phone ? '(' + formatPhone(this.driver.phone) + ')' : '';
};

DistributionRoute.prototype.status = function() {
  return (this.timestampStop && 'finished') ||
         (this.timestampStart && 'started') ||
         'notStarted';
};

DistributionRoute.prototype.sortableDelay = function() {

  var delay = function(timestamp, estimatedTimestamp) {
    if (timestamp && estimatedTimestamp && timestamp > estimatedTimestamp) {
      return timestamp.getTime() - estimatedTimestamp.getTime();
    }
    return 0;
  };

  if (! this.timestampStart) {
    return 300000000000 + delay(new Date(), this.estimatedTimestampStart);
  }

  if (this.timestampStop) {
    return 100000000000 + delay(this.timestampStop, this.estimatedTimestampStop);
  }

  if (this.timestampDelivery) {
    return 200000000000 + delay(this.timestampDelivery, this.estimatedTimestampDelivery);
  }

  return 200000000000 + delay(this.timestampStart, this.estimatedTimestampStart);
};

DistributionRoute.prototype.percentageHandled = function() {
  return (this.customerCount - this.customerRemainingCount) / this.customerCount;
};


module.exports = DistributionRoute;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/distributionRoute.js
 ** module id = 170
 ** module chunks = 1
 **/